var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('assessment',{attrs:{"assessment-id":_vm.assessmentId,"allow-finish-later":_vm.allowFinishLater},on:{"assessment-complete":_vm.assessmentComplete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }